import { a as er } from "./_commonjsHelpers-c5d32002.js";
var tr = Error, or = EvalError, nr = RangeError, ar = ReferenceError, Y = SyntaxError, _ = TypeError, ir = URIError, yr = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var r = {}, e = Symbol("test"), t = Object(e);
  if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(t) !== "[object Symbol]")
    return !1;
  var o = 42;
  r[e] = o;
  for (e in r)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(r).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(r).length !== 0)
    return !1;
  var i = Object.getOwnPropertySymbols(r);
  if (i.length !== 1 || i[0] !== e || !Object.prototype.propertyIsEnumerable.call(r, e))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var y = Object.getOwnPropertyDescriptor(r, e);
    if (y.value !== o || y.enumerable !== !0)
      return !1;
  }
  return !0;
}, T = typeof Symbol < "u" && Symbol, pr = yr, lr = function() {
  return typeof T != "function" || typeof Symbol != "function" || typeof T("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : pr();
}, G = {
  foo: {}
}, fr = Object, ur = function() {
  return { __proto__: G }.foo === G.foo && !({ __proto__: null } instanceof fr);
}, sr = "Function.prototype.bind called on incompatible ", cr = Object.prototype.toString, vr = Math.max, gr = "[object Function]", M = function(r, e) {
  for (var t = [], o = 0; o < r.length; o += 1)
    t[o] = r[o];
  for (var i = 0; i < e.length; i += 1)
    t[i + r.length] = e[i];
  return t;
}, dr = function(r, e) {
  for (var t = [], o = e || 0, i = 0; o < r.length; o += 1, i += 1)
    t[i] = r[o];
  return t;
}, br = function(a, r) {
  for (var e = "", t = 0; t < a.length; t += 1)
    e += a[t], t + 1 < a.length && (e += r);
  return e;
}, mr = function(r) {
  var e = this;
  if (typeof e != "function" || cr.apply(e) !== gr)
    throw new TypeError(sr + e);
  for (var t = dr(arguments, 1), o, i = function() {
    if (this instanceof o) {
      var u = e.apply(
        this,
        M(t, arguments)
      );
      return Object(u) === u ? u : this;
    }
    return e.apply(
      r,
      M(t, arguments)
    );
  }, y = vr(0, e.length - t.length), p = [], l = 0; l < y; l++)
    p[l] = "$" + l;
  if (o = Function("binder", "return function (" + br(p, ",") + "){ return binder.apply(this,arguments); }")(i), e.prototype) {
    var c = function() {
    };
    c.prototype = e.prototype, o.prototype = new c(), c.prototype = null;
  }
  return o;
}, hr = mr, D = Function.prototype.bind || hr, Ar = Function.prototype.call, Pr = Object.prototype.hasOwnProperty, Sr = D, Er = Sr.call(Ar, Pr), n, wr = tr, Ir = or, Fr = nr, Or = ar, S = Y, P = _, $r = ir, H = Function, x = function(a) {
  try {
    return H('"use strict"; return (' + a + ").constructor;")();
  } catch {
  }
}, g = Object.getOwnPropertyDescriptor;
if (g)
  try {
    g({}, "");
  } catch {
    g = null;
  }
var B = function() {
  throw new P();
}, Rr = g ? function() {
  try {
    return arguments.callee, B;
  } catch {
    try {
      return g(arguments, "callee").get;
    } catch {
      return B;
    }
  }
}() : B, m = lr(), _r = ur(), f = Object.getPrototypeOf || (_r ? function(a) {
  return a.__proto__;
} : null), A = {}, xr = typeof Uint8Array > "u" || !f ? n : f(Uint8Array), d = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? n : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? n : ArrayBuffer,
  "%ArrayIteratorPrototype%": m && f ? f([][Symbol.iterator]()) : n,
  "%AsyncFromSyncIteratorPrototype%": n,
  "%AsyncFunction%": A,
  "%AsyncGenerator%": A,
  "%AsyncGeneratorFunction%": A,
  "%AsyncIteratorPrototype%": A,
  "%Atomics%": typeof Atomics > "u" ? n : Atomics,
  "%BigInt%": typeof BigInt > "u" ? n : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? n : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? n : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? n : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": wr,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": Ir,
  "%Float32Array%": typeof Float32Array > "u" ? n : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? n : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? n : FinalizationRegistry,
  "%Function%": H,
  "%GeneratorFunction%": A,
  "%Int8Array%": typeof Int8Array > "u" ? n : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? n : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? n : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": m && f ? f(f([][Symbol.iterator]())) : n,
  "%JSON%": typeof JSON == "object" ? JSON : n,
  "%Map%": typeof Map > "u" ? n : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !m || !f ? n : f((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? n : Promise,
  "%Proxy%": typeof Proxy > "u" ? n : Proxy,
  "%RangeError%": Fr,
  "%ReferenceError%": Or,
  "%Reflect%": typeof Reflect > "u" ? n : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? n : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !m || !f ? n : f((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? n : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": m && f ? f(""[Symbol.iterator]()) : n,
  "%Symbol%": m ? Symbol : n,
  "%SyntaxError%": S,
  "%ThrowTypeError%": Rr,
  "%TypedArray%": xr,
  "%TypeError%": P,
  "%Uint8Array%": typeof Uint8Array > "u" ? n : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? n : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? n : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? n : Uint32Array,
  "%URIError%": $r,
  "%WeakMap%": typeof WeakMap > "u" ? n : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? n : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? n : WeakSet
};
if (f)
  try {
    null.error;
  } catch (a) {
    var Br = f(f(a));
    d["%Error.prototype%"] = Br;
  }
var Ur = function a(r) {
  var e;
  if (r === "%AsyncFunction%")
    e = x("async function () {}");
  else if (r === "%GeneratorFunction%")
    e = x("function* () {}");
  else if (r === "%AsyncGeneratorFunction%")
    e = x("async function* () {}");
  else if (r === "%AsyncGenerator%") {
    var t = a("%AsyncGeneratorFunction%");
    t && (e = t.prototype);
  } else if (r === "%AsyncIteratorPrototype%") {
    var o = a("%AsyncGenerator%");
    o && f && (e = f(o.prototype));
  }
  return d[r] = e, e;
}, k = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, E = D, $ = Er, jr = E.call(Function.call, Array.prototype.concat), Dr = E.call(Function.apply, Array.prototype.splice), C = E.call(Function.call, String.prototype.replace), R = E.call(Function.call, String.prototype.slice), Nr = E.call(Function.call, RegExp.prototype.exec), Tr = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Gr = /\\(\\)?/g, Mr = function(r) {
  var e = R(r, 0, 1), t = R(r, -1);
  if (e === "%" && t !== "%")
    throw new S("invalid intrinsic syntax, expected closing `%`");
  if (t === "%" && e !== "%")
    throw new S("invalid intrinsic syntax, expected opening `%`");
  var o = [];
  return C(r, Tr, function(i, y, p, l) {
    o[o.length] = p ? C(l, Gr, "$1") : y || i;
  }), o;
}, kr = function(r, e) {
  var t = r, o;
  if ($(k, t) && (o = k[t], t = "%" + o[0] + "%"), $(d, t)) {
    var i = d[t];
    if (i === A && (i = Ur(t)), typeof i > "u" && !e)
      throw new P("intrinsic " + r + " exists, but is not available. Please file an issue!");
    return {
      alias: o,
      name: t,
      value: i
    };
  }
  throw new S("intrinsic " + r + " does not exist!");
}, w = function(r, e) {
  if (typeof r != "string" || r.length === 0)
    throw new P("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof e != "boolean")
    throw new P('"allowMissing" argument must be a boolean');
  if (Nr(/^%?[^%]*%?$/, r) === null)
    throw new S("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var t = Mr(r), o = t.length > 0 ? t[0] : "", i = kr("%" + o + "%", e), y = i.name, p = i.value, l = !1, c = i.alias;
  c && (o = c[0], Dr(t, jr([0, 1], c)));
  for (var u = 1, v = !0; u < t.length; u += 1) {
    var s = t[u], b = R(s, 0, 1), I = R(s, -1);
    if ((b === '"' || b === "'" || b === "`" || I === '"' || I === "'" || I === "`") && b !== I)
      throw new S("property names with quotes must have matching quotes");
    if ((s === "constructor" || !v) && (l = !0), o += "." + s, y = "%" + o + "%", $(d, y))
      p = d[y];
    else if (p != null) {
      if (!(s in p)) {
        if (!e)
          throw new P("base intrinsic for " + r + " exists, but the property is not available.");
        return;
      }
      if (g && u + 1 >= t.length) {
        var F = g(p, s);
        v = !!F, v && "get" in F && !("originalValue" in F.get) ? p = F.get : p = p[s];
      } else
        v = $(p, s), p = p[s];
      v && !l && (d[y] = p);
    }
  }
  return p;
}, U, W;
function N() {
  if (W)
    return U;
  W = 1;
  var a = w, r = a("%Object.defineProperty%", !0) || !1;
  if (r)
    try {
      r({}, "a", { value: 1 });
    } catch {
      r = !1;
    }
  return U = r, U;
}
var j = N(), K = function() {
  return !!j;
};
K.hasArrayLengthDefineBug = function() {
  if (!j)
    return null;
  try {
    return j([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var Cr = K, Wr = w, O = Wr("%Object.getOwnPropertyDescriptor%", !0);
if (O)
  try {
    O([], "length");
  } catch {
    O = null;
  }
var Q = O, X = { exports: {} }, L = N(), Lr = Y, h = _, J = Q, Jr = function(r, e, t) {
  if (!r || typeof r != "object" && typeof r != "function")
    throw new h("`obj` must be an object or a function`");
  if (typeof e != "string" && typeof e != "symbol")
    throw new h("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new h("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new h("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new h("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new h("`loose`, if provided, must be a boolean");
  var o = arguments.length > 3 ? arguments[3] : null, i = arguments.length > 4 ? arguments[4] : null, y = arguments.length > 5 ? arguments[5] : null, p = arguments.length > 6 ? arguments[6] : !1, l = !!J && J(r, e);
  if (L)
    L(r, e, {
      configurable: y === null && l ? l.configurable : !y,
      enumerable: o === null && l ? l.enumerable : !o,
      value: t,
      writable: i === null && l ? l.writable : !i
    });
  else if (p || !o && !i && !y)
    r[e] = t;
  else
    throw new Lr("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Vr = w, V = Jr, qr = Cr(), q = Q, z = _, zr = Vr("%Math.floor%"), Yr = function(r, e) {
  if (typeof r != "function")
    throw new z("`fn` is not a function");
  if (typeof e != "number" || e < 0 || e > 4294967295 || zr(e) !== e)
    throw new z("`length` must be a positive 32-bit integer");
  var t = arguments.length > 2 && !!arguments[2], o = !0, i = !0;
  if ("length" in r && q) {
    var y = q(r, "length");
    y && !y.configurable && (o = !1), y && !y.writable && (i = !1);
  }
  return (o || i || !t) && (qr ? V(
    /** @type {Parameters<define>[0]} */
    r,
    "length",
    e,
    !0,
    !0
  ) : V(
    /** @type {Parameters<define>[0]} */
    r,
    "length",
    e
  )), r;
};
(function(a) {
  var r = D, e = w, t = Yr, o = _, i = e("%Function.prototype.apply%"), y = e("%Function.prototype.call%"), p = e("%Reflect.apply%", !0) || r.call(y, i), l = N(), c = e("%Math.max%");
  a.exports = function(s) {
    if (typeof s != "function")
      throw new o("a function is required");
    var b = p(r, y, arguments);
    return t(
      b,
      1 + c(0, s.length - (arguments.length - 1)),
      !0
    );
  };
  var u = function() {
    return p(r, i, arguments);
  };
  l ? l(a.exports, "apply", { value: u }) : a.exports.apply = u;
})(X);
var Hr = X.exports, Z = w, rr = Hr, Kr = rr(Z("String.prototype.indexOf")), re = function(r, e) {
  var t = Z(r, !!e);
  return typeof t == "function" && Kr(r, ".prototype.") > -1 ? rr(t) : t;
};
const Qr = {}, Xr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qr
}, Symbol.toStringTag, { value: "Module" })), ee = /* @__PURE__ */ er(Xr);
export {
  Q as a,
  Hr as b,
  re as c,
  lr as d,
  w as g,
  Cr as h,
  ee as r,
  yr as s,
  _ as t
};
//# sourceMappingURL=___vite-browser-external_commonjs-proxy-820355ce.js.map
